import { Typography } from 'components/Contentful'
import { Slider } from '@achieve/ascend'

function TermSlider({ jsonConfig, loanPayments, term, handleChangeTerm }) {
  return (
    <>
      <Typography
        content={jsonConfig?.termTitle || 'Term'}
        variant="bodyLg"
        mobileVariant="bodySm"
        responsive={true}
        data-testid="heloc-term"
        className=" text-[#42546B]"
      />

      <Typography
        content={`${loanPayments[term - 1]?.term} yr`}
        variant="headingMd"
        fontWeight="bold"
        className="py-2"
      />
      {loanPayments?.length && (
        <>
          <Slider
            aria-label="term-selection-slider"
            classes={{
              mark: 'hidden',
            }}
            data-testid="heloc-term-form"
            value={term}
            min={1}
            max={loanPayments?.length}
            step={1}
            marks={[
              ...loanPayments.map((e, pos) => {
                return {
                  value: pos + 1,
                  label: (
                    <Typography
                      content={`${e?.term} yr`}
                      variant="bodySm"
                      fontWeight="regular"
                      className={`text-[#5C708A] ${pos === 0 && 'ml-8'} ${
                        pos + 1 === loanPayments.length && 'mr-10'
                      }`}
                    />
                  ),
                }
              }),
            ]}
            onChange={handleChangeTerm}
          />
        </>
      )}
    </>
  )
}

export { TermSlider }
